module.exports = __webpack_public_path__ + "static/media/moveIcon.8d985aeb.svg";